import axiosInstance from "@/utils/axios";

export const bookersApi = {
  getAll: (params = {}) => axiosInstance.get("/api/bookers", { params }),
  search: (query) => axiosInstance.get("/api/bookers/search", { params: { query } }),
  getById: (bookerId) => axiosInstance.get(`/api/bookers/${bookerId}`),
  getHistory: (bookerId) => axiosInstance.get(`/api/bookers/${bookerId}/history`),
  create: (payload) => axiosInstance.post("/api/bookers", payload),
  update: (bookerId, payload) => axiosInstance.put(`/api/bookers/${bookerId}`, payload),
  updateStatus: (bookerId, status) =>
    axiosInstance.patch(`/api/bookers/${bookerId}/status`, null, { params: { status } }),
};

export const bookerRewardsApi = {
  getProgram: () => axiosInstance.get("/api/booker-rewards/program"),
  saveProgram: (payload) => axiosInstance.put("/api/booker-rewards/program", payload),
  createRule: (payload) => axiosInstance.post("/api/booker-rewards/rules", payload),
  updateRule: (ruleId, payload) => axiosInstance.put(`/api/booker-rewards/rules/${ruleId}`, payload),
  createTier: (payload) => axiosInstance.post("/api/booker-rewards/tiers", payload),
  updateTier: (tierId, payload) => axiosInstance.put(`/api/booker-rewards/tiers/${tierId}`, payload),
  createRedemptionRule: (payload) => axiosInstance.post("/api/booker-rewards/redemption-rules", payload),
  updateRedemptionRule: (ruleId, payload) =>
    axiosInstance.put(`/api/booker-rewards/redemption-rules/${ruleId}`, payload),
  getTransactions: (params = {}) => axiosInstance.get("/api/booker-rewards/transactions", { params }),
  getReports: (params = {}) => axiosInstance.get("/api/booker-rewards/reports", { params }),
  adjustPoints: (bookerId, payload) => axiosInstance.post(`/api/booker-rewards/bookers/${bookerId}/adjustment`, payload),
  getCoupons: (bookerId) => axiosInstance.get(`/api/booker-rewards/bookers/${bookerId}/coupons`),
  createCoupon: (payload) => axiosInstance.post("/api/booker-rewards/coupons", payload),
  redeemPoints: (payload) => axiosInstance.post("/api/booker-rewards/redeem-points", payload),
  redeemCoupon: (payload) => axiosInstance.post("/api/booker-rewards/redeem-coupon", payload),
};

export const bookerPortalApi = {
  dashboard: () => axiosInstance.get("/api/booker-portal/dashboard"),
  bookings: () => axiosInstance.get("/api/booker-portal/bookings"),
  rewards: () => axiosInstance.get("/api/booker-portal/rewards"),
  coupons: () => axiosInstance.get("/api/booker-portal/coupons"),
  updateProfile: (payload) => axiosInstance.put("/api/booker-portal/profile", payload),
};
